import { createStore } from 'vuex';
import Application from '@/store/modules/application';
import Error from '@/store/modules/error';

export default createStore({
  modules: { Application, Error },
  strict: process.env.NODE_ENV !== 'production',
});
